import { MessageBar, MessageBarBody, makeStyles, tokens } from '@fluentui/react-components';
import { useT } from '@powerportalspro/react';
import { MainGrid } from '@powerportalspro/react-fluent';
import { useMemo } from 'react';
import { ALL_CONTACTS_VIEW_ID, getAllContactsView } from './AccountAndContactCustomViews';
import { CONTACTS_WITH_COMPANY_CITY_VIEW_ID, getContactsWithCompanyCityView } from './AdvancedFilteringViews';

// The sample contacts, with the toolbar's Filter button (`allowFiltering`). It opens the view's own
// filters in the FetchXML query builder, to change: conditions on the contact's columns, grouped
// with AND and OR, compared with a value or with another column, and related tables to filter by.
// Apply shows the rows that match, from the first page; Reset to view, applied, puts the view back as
// it opens — its own filters, sort and columns — and another view picked starts from its own.
//
// Two views to start from: All Contacts, whose filter is an OR group, and Contacts at Companies with
// a City, which joins each contact's company and keeps those whose company has a city — a related
// table with a condition of its own. Only the columns and related tables the user may read are
// offered.

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.GridDemos.GridAdvancedFilteringMainDemo';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalMNudge,
  },
});

export function GridAdvancedFilteringMainSample() {
  const styles = useStyles();
  const t = useT();
  const companyCityViewName = t(`${STRINGS_BASE}.view-contacts-with-company-city`);

  const contactViews = useMemo(
    () => [getAllContactsView(), getContactsWithCompanyCityView(companyCityViewName)],
    [companyCityViewName],
  );

  return (
    <div className={styles.root}>
      <MessageBar intent="warning" layout="multiline">
        <MessageBarBody>{t(`${STRINGS_BASE}.login-required`)}</MessageBarBody>
      </MessageBar>

      <MainGrid
        tableName="contact"
        minHeight="450px"
        maxHeight="450px"
        pageSize={10}
        viewIds={[ALL_CONTACTS_VIEW_ID, CONTACTS_WITH_COMPANY_CITY_VIEW_ID]}
        customViewDefinitions={contactViews}
        defaultViewId={ALL_CONTACTS_VIEW_ID}
        allowFiltering
      />
    </div>
  );
}
